'use client';

import { useMeQuery } from '@/entities/me/meQueries';

export const useIsAdmin = () => {
  /** isPending у disabled-запроса без данных в RQ5 остаётся true — для гейта нужен именно «идёт fetch». */
  const { data: user, isLoading } = useMeQuery();
  return { isAdmin: user?.role?.type === 'admin', isPending: isLoading };
};
